//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CollapsiblePanel',

  props: {
    /** When set (including `false`), the panel is controlled via `v-model`. */
    value: {
      type: Boolean,
      default: undefined,
    },
    /** Used only when `value` is not passed (uncontrolled). */
    initialExpanded: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideChevron: {
      type: Boolean,
      default: false,
    },
    /** Stable id for `aria-controls` / `b-collapse`; auto if omitted. */
    contentId: {
      type: String,
      default: null,
    },
    rootClass: {
      type: [String, Array, Object],
      default: null,
    },
    triggerClass: {
      type: [String, Array, Object],
      default: null,
    },
    bodyClass: {
      type: [String, Array, Object],
      default: null,
    },
  },

  data() {
    return {
      faChevronDown,
      localExpanded: this.initialExpanded,
    };
  },

  computed: {
    isControlled() {
      return this.value !== undefined;
    },
    expanded: {
      get() {
        return this.isControlled ? this.value : this.localExpanded;
      },
      set(next) {
        if (this.isControlled) {
          this.$emit('input', next);
        } else {
          this.localExpanded = next;
        }
        this.$emit('change', next);
      },
    },
    resolvedContentId() {
      // eslint-disable-next-line no-underscore-dangle
      return this.contentId || `collapsible-panel-${this._uid}`;
    },
  },

  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      this.expanded = !this.expanded;
    },
  },
};
